/**
 * standNaming.js — stand adının FE tarafındaki tek tarifi
 *
 * Backend'de bu iş 2026-09-03'ten beri tek bir sınıfta yaşıyor
 * (`util/StandNaming.java`); burası onun frontend karşılığı, aynı sebeple tek dosya:
 * ad kuralının iki kopyası olduğu anda ikisi ayrışıyor.
 *
 * Rehber: docs/guides/FE-StandTalepController-guide.md → "Stand naming — one recipe,
 * composed server-side".
 *
 * ─── TARİF ──────────────────────────────────────────────────────────────────────
 *     salon.salon_name  "11"   +   standCode  "A10"   →   stand_name  "11.A10"
 *
 * Adın HOL YARISI HER ZAMAN salonun kendi adından gelir; gönderdiğimiz bir metinden
 * değil. Frontend artık `standCode` yazar, tam adı SUNUCU kurar — buradaki
 * `composeStandName` yalnızca formda gösterilen ÖN İZLEME içindir. Yazma sonrası
 * gerçek ad, yanıtın `standName` alanıdır; yeniden türetmeyin.
 *
 * ⚠️ Bilerek dependency-free: hem servisler hem bileşenler import ediyor.
 */

/**
 * Tam addan stand kodunu çıkarır — backend'in okuma tarafındaki parse'ının aynısı:
 * İLK noktadan sonrası koddur, nokta yoksa adın tamamı koddur.
 *   "11.A10"      → "A10"
 *   "11a.11AF43"  → "11AF43"
 *   "B430"        → "B430"
 *   "8.F110.1"    → "F110.1"   (yalnızca İLK nokta böler — kodun kendisi nokta
 *                               içerebilir ve canlı veride içeriyor)
 *
 * ⚠️ Roster (`GET /standTalep/list`) `standCode`'u zaten döndürüyor — varsa ONU
 * kullanın; bu yardımcı kodun gelmediği okumalar (`/detay`, `/basicStandInfo`,
 * `/standBySalonId`) için bir yedek.
 */
export function standCodeFromName(standName) {
  const s = String(standName || '').trim();
  const i = s.indexOf('.');
  return i > 0 ? s.slice(i + 1) : s;
}

/**
 * Ön izleme için tam adı kurar — sunucudaki kompozisyonun FE kopyası.
 *
 * Idempotent: kod zaten bu holün adıyla başlıyorsa önek iki kez eklenmez
 * ("11.A10" + hol "11" → "11.A10", "11.11.A10" değil) — sunucu da öyle davranıyor.
 *
 * ⚠️ Sunucu, TAŞIMADA terk edilen holün önekini de soyar; burada yalnızca hedef hol
 * biliniyor. Fark yalnızca ön izlemeyi etkiler, yazılan adı değil.
 * ⚠️ Hol adı yoksa ÇIPLAK kod döner, asla ".A10" — baştaki nokta boş hol gibi parse
 * edilir ve bozulma gibi görünür (sunucudaki kural da bu).
 */
export function composeStandName(salonName, standCode) {
  const code = String(standCode || '').trim();
  const hall = String(salonName || '').trim();
  if (!code) return '';
  if (!hall) return code;
  return code.startsWith(`${hall}.`) ? code : `${hall}.${code}`;
}

/**
 * #547: yazma (POST /standTalep/create, PUT /standTalep/update/{id}) bu holde aynı adlı BAŞKA bir canlı stand
 * olduğu için reddedildi mi? Backend (#546) iki uçta da 409 + `messageKey: "stand.adi_salonda_var"` döndürüyor;
 * `message` zaten isteğin dilinde. Formlar metni olduğu gibi gösterir, bu yardımcı yalnızca kod alanını
 * kırmızıya boyamak için ayırt eder. 409'un bu iki uçta başka anlamı yok, o yüzden anahtar yoksa da (eski
 * backend) 409 yeterli.
 */
export function isStandAdiCakismasi(error) {
  const res = error?.response;
  if (res?.status !== 409) return false;
  const key = res?.data?.messageKey;
  return key === undefined || key === null || key === 'stand.adi_salonda_var';
}
